var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("common-layout-component2", {
    attrs: {
      "show-back": "false",
      "show-user": "false",
      "show-admin": "false",
      "show-logout": "false",
      "show-notice": false
    },
    scopedSlots: _vm._u([
      {
        key: "nav-message",
        fn: function() {
          return [_c("p", [_vm._v("お探しのページが見つかりませんでした")])]
        },
        proxy: true
      },
      {
        key: "body",
        fn: function() {
          return [
            _c("div", { staticClass: "container" }, [
              _c("div", { staticClass: "columns is-multiline cat-wrapper" }, [
                _c("div", { staticClass: "column cat-item top" }, [
                  _c(
                    "a",
                    {
                      attrs: { href: "javascript:void(0)" },
                      on: {
                        click: function($event) {
                          return _vm.navTo("/admin/menu", 1)
                        }
                      }
                    },
                    [
                      _c("h3", { staticStyle: { "text-align": "center" } }, [
                        _vm._v("トップページへ戻る")
                      ])
                    ]
                  )
                ])
              ])
            ])
          ]
        },
        proxy: true
      }
    ])
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }